import "./kendo_info.8179fdb6.js";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref36d"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref36d"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $exTRt = parcelRequire("exTRt");

var $k1bt3 = parcelRequire("k1bt3");
var $d8dc065bc5fd4495$exports = {};
$d8dc065bc5fd4495$exports = ":::header-button_start\nAloita tästä\n:::\n\n:::header-button_member\nJäsensivut\n:::\n\n:::header-widget_title\nTulevat treenit\n:::\n\n:::header-title\nPorvoon kendoseura\n:::\n\n:::header-content\nKevään 2026 alkeiskurssi alkaa 16.2.2026 Eklöfska skolanilla\nTolkkisissa (Palomäentie 5, 06750 Tolkkinen - katso tarkemmat ajo-ohjeet jäsensivulta). Alkuun et\ntarvitse varusteita, voit lainata miekkoja alkuun muilta\nseuralaisilta.\n:::\n";


var $d0aa8a46c458f3a6$exports = {};
$d0aa8a46c458f3a6$exports = ":::header-button_start\nBörja här\n:::\n\n:::header-button_member\nMedlemssidor\n:::\n\n:::header-widget_title\nKommande träningar\n:::\n\n:::header-title\nBorgå Kendo\n:::\n\n:::header-content\nVårens nybörjarkurs 2026 börjar den 16.2.2026 på Eklöfska skolan i\nTolkkis (Brännbackavägen 5, 06750 Tolkis - se mer detaljerade vägbeskrivningar på medlemssidan). Du behöver ingen egen utrustning i början – svärd kan lånas av andra medlemmar i föreningen.\n:::\n";


var $6d33281148746fa5$exports = {};
$6d33281148746fa5$exports = ":::header-button_start\nGet Started\n:::\n\n:::header-button_member\nMember Pages\n:::\n\n:::header-widget_title\nUpcoming practices\n:::\n\n:::header-title\nPorvoo Kendo\n:::\n\n:::header-content\nThe spring 2026 beginners’ course starts on 16 February 2026 at Eklöfska skolan in\nTolkkinen (Palomäentie 5, 06750 Tolkkinen - see more detailed directions on the members’ page). You don’t need any equipment at the start – swords can be borrowed from other club members.\n:::\n";


var $5fc65d429b8d7bbe$exports = {};
$5fc65d429b8d7bbe$exports = ":::hero-title\nKendosta lyhyesti\n:::\n\n:::hero-content\nKendo (jap. 剣道) on moderni japanilainen kamppailulaji, joka juontaa juurensa vanhasta kenjutsusta, eli miekkailun perinteistä. Suomessa kendoa on harjoitettu vuodesta 1986 alkaen, ja Porvoon seura on yksiä Suomen vanhimmista kendoseuroista. Suomen Kendoseurojen Keskusliitto ry (FKA) ohjaa lajia valtakunnallisesti ja edustaa Suomen seuratoimintaa myös kansainvälisesti.\n\nKendon harjoittelu kehittää niin kehoa kuin mieltä: oikealla tekniikalla pyritään tavoittelemaan motorisen taidon kehittymisen lisäksi myös itsekuria ja henkistä kasvua.\n\nVarusteiden keskiössä on neljästä bambusäleestä koostuva shinai-miekka, sekä bogu-panssari, joka suojaa harrastajaa vahingoilta.\n:::\n";


var $e0253fd1928ffe52$exports = {};
$e0253fd1928ffe52$exports = ":::hero-title\nKort om kendo\n:::\n\n:::hero-content\nKendo (jap. 剣道) är en modern japansk kampsport som har sina rötter i det gamla kenjutsu, alltså svärdskonstens traditioner. I Finland har kendo utövats sedan 1986, och Borgåklubben är en av de äldsta kendoklubbarna i landet. Finlands Kendoförbund (FKA) styr sporten nationellt och representerar den finländska verksamheten även internationellt.\n\nTräningen i kendo utvecklar både kropp och sinne: med rätt teknik strävar man inte bara efter motorisk färdighet, utan också självdisciplin och mental utveckling.\n\nI centrum för utrustningen står shinai-svärdet, som består av fyra bambulister, samt bogu-rustningen, som skyddar utövaren mot skador.\n:::\n";


var $6955a5afe0aeb685$exports = {};
$6955a5afe0aeb685$exports = ":::hero-title\nAbout Kendo\n:::\n\n:::hero-content\nKendo (Jap. 剣道) is a modern Japanese martial art that has its roots in the old kenjutsu, the traditional art of swordsmanship. In Finland, kendo has been practiced since 1986, and the Porvoo club is one of the oldest kendo clubs in the country. The Finnish Kendo Association (FKA) oversees the sport nationally and represents Finland’s activities internationally.\n\nKendo training develops both body and mind: with correct technique the aim is not only to improve motor skills, but also to cultivate self-discipline and mental growth.\n\nAt the heart of the equipment is the shinai, a sword made of four bamboo slats, along with the bogu armor, which protects the practitioner from injury.\n:::\n";


var $ad6d3fba847ae3b3$exports = {};
$ad6d3fba847ae3b3$exports = ":::contact_form-button_submit\nLähetä\n:::\n\n:::contact_form-name\nNimi\n:::\n\n:::contact_form-email\nSähköposti\n:::\n\n:::contact_form-tel\nPuhelinnumero\n:::\n\n:::contact_form-message\nViesti\n:::\n\n:::contact_form-title\nJätä viesti, niin otamme yhteyttä!\n:::\n";


var $6621a6e1e7c99d88$exports = {};
$6621a6e1e7c99d88$exports = ":::contact_form-button_submit\nSkicka\n:::\n\n:::contact_form-name\nNamn\n:::\n\n:::contact_form-email\nE-post\n:::\n\n:::contact_form-tel\nTelefonnummer\n:::\n\n:::contact_form-message\nMeddelande\n:::\n\n:::contact_form-title\nLämna ett meddelande så kontaktar vi dig!\n:::\n";


var $8d18abdd13249cd7$exports = {};
$8d18abdd13249cd7$exports = ":::contact_form-button_submit\nSend\n:::\n\n:::contact_form-name\nName\n:::\n\n:::contact_form-email\nEmail\n:::\n\n:::contact_form-tel\nPhone number\n:::\n\n:::contact_form-message\nMessage\n:::\n\n:::contact_form-title\nLeave a message and we will contact you!\n:::\n";


var $ec30601203ba6ff7$exports = {};
$ec30601203ba6ff7$exports = ":::link-mainpage\nKoti\n:::\n\n:::link-memberpage\nSeura\n:::\n\n:::link-infopage\nLaji-info\n:::\n";


var $6355d7facbb75388$exports = {};
$6355d7facbb75388$exports = ":::link-mainpage\nHem\n:::\n\n:::link-memberpage\nMedlemmar\n:::\n\n:::link-infopage\nKendoinfo\n:::\n";


var $884e8afb6dc65868$exports = {};
$884e8afb6dc65868$exports = ":::link-mainpage\nHome\n:::\n\n:::link-memberpage\nMembers\n:::\n\n:::link-infopage\nAbout\n:::\n";


var $117544d934ea3d70$exports = {};
$117544d934ea3d70$exports = ":::footer-businessId\nY-tunnus\n:::\n\n:::footer-chairPerson\nPuheenjohtaja\n:::\n\n:::footer-currentChair\nJoonas Joensuu, kendo 2.dan\n:::\n\n:::footer-communication\nSeuransisäinen kommunikaatio\n:::\n\n:::footer-group\nryhmä\n:::\n\n:::footer-followUs\nSeuraa meitä\n:::\n\n:::footer-fkaMember\nSuomen Kendoseurojen Keskusliitto jäsen\n:::\n";


var $c3faa4a26c58d3cd$exports = {};
$c3faa4a26c58d3cd$exports = ":::footer-businessId\nFO-nummer\n:::\n\n:::footer-chairPerson\nOrdförande\n:::\n\n:::footer-currentChair\nJoonas Joensuu, kendo 2.dan\n:::\n\n:::footer-communication\nIntern kommunikation\n:::\n\n:::footer-group\ngrupp\n:::\n\n:::footer-followUs\nFölj oss\n:::\n\n:::footer-fkaMember\nMedlem i Finlands Kendoförbund\n:::\n";


var $56ccc9d004f8bad8$exports = {};
$56ccc9d004f8bad8$exports = ":::footer-businessId\nBusiness ID\n:::\n\n:::footer-chairPerson\nChairperson\n:::\n\n:::footer-currentChair\nJoonas Joensuu, kendo 2nd dan\n:::\n\n:::footer-communication\nInternal communication\n:::\n\n:::footer-group\ngroup\n:::\n\n:::footer-followUs\nFollow us\n:::\n\n:::footer-fkaMember\nMember of the Finnish Kendo Association\n:::\n";


const $e867405a5d233f6c$var$markdownContent = {
    fi: {
        navbar: (0, (/*@__PURE__*/$parcel$interopDefault($ec30601203ba6ff7$exports))),
        header: (0, (/*@__PURE__*/$parcel$interopDefault($d8dc065bc5fd4495$exports))),
        hero: (0, (/*@__PURE__*/$parcel$interopDefault($5fc65d429b8d7bbe$exports))),
        contact_form: (0, (/*@__PURE__*/$parcel$interopDefault($ad6d3fba847ae3b3$exports))),
        footer: (0, (/*@__PURE__*/$parcel$interopDefault($117544d934ea3d70$exports)))
    },
    sv: {
        navbar: (0, (/*@__PURE__*/$parcel$interopDefault($6355d7facbb75388$exports))),
        header: (0, (/*@__PURE__*/$parcel$interopDefault($d0aa8a46c458f3a6$exports))),
        hero: (0, (/*@__PURE__*/$parcel$interopDefault($e0253fd1928ffe52$exports))),
        contact_form: (0, (/*@__PURE__*/$parcel$interopDefault($6621a6e1e7c99d88$exports))),
        footer: (0, (/*@__PURE__*/$parcel$interopDefault($c3faa4a26c58d3cd$exports)))
    },
    en: {
        navbar: (0, (/*@__PURE__*/$parcel$interopDefault($884e8afb6dc65868$exports))),
        header: (0, (/*@__PURE__*/$parcel$interopDefault($6d33281148746fa5$exports))),
        hero: (0, (/*@__PURE__*/$parcel$interopDefault($6955a5afe0aeb685$exports))),
        contact_form: (0, (/*@__PURE__*/$parcel$interopDefault($8d18abdd13249cd7$exports))),
        footer: (0, (/*@__PURE__*/$parcel$interopDefault($56ccc9d004f8bad8$exports)))
    }
};
class $e867405a5d233f6c$var$PlaceholderParser extends (0, $exTRt.MarkDownTokenParser) {
    async render() {
        const resultObj = await this.data;
        const keys = Object.keys(resultObj);
        keys.forEach((key)=>{
            // console.log(`Rendering ${key}`);
            const currElement = document.querySelector(`#${key}`);
            if ([
                "contact_form-button_submit",
                "contact_form-title"
            ].includes(key)) {
                // console.log(`Setting ${key} to value ${resultObj[key]}`);
                currElement.innerHTML = resultObj[key];
                currElement.classList.remove("placeholder", "placeholder-wave");
            } else {
                const placeholderString = resultObj[key].trim().replace(/^<p>|<\/p>$/g, "");
                // console.log(`Setting ${key} to value ${placeholderString}`);
                currElement.setAttribute("placeholder", placeholderString); // = resultObj[key];
            }
        });
    }
}
async function $e867405a5d233f6c$var$renderContent(lang = "fi") {
    const navbarContent = new (0, $exTRt.MarkDownTokenParser)($e867405a5d233f6c$var$markdownContent[lang].navbar);
    const headerContent = new (0, $exTRt.MarkDownTokenParser)($e867405a5d233f6c$var$markdownContent[lang].header);
    const heroContent = new (0, $exTRt.MarkDownTokenParser)($e867405a5d233f6c$var$markdownContent[lang].hero);
    const contactFormContent = new $e867405a5d233f6c$var$PlaceholderParser($e867405a5d233f6c$var$markdownContent[lang].contact_form);
    const footerContent = new (0, $exTRt.MarkDownTokenParser)($e867405a5d233f6c$var$markdownContent[lang].footer);
    await navbarContent.render();
    await headerContent.render();
    await heroContent.render();
    await contactFormContent.render();
    await footerContent.render();
}
document.addEventListener("DOMContentLoaded", ()=>{
    (0, $k1bt3.loadNavBar)().then(()=>{
        // console.log("Navbar loaded");
        (0, $k1bt3.darkenNavBar)();
        const languageButtons = document.querySelector("#navbar-changeLanguage");
        const languageFlags = document.querySelectorAll(".navbar-language-flag");
        // console.log(languageButtons);
        languageButtons.addEventListener("click", (e)=>{
            e.preventDefault();
            // console.log("Ping");
            if (e.target.id === "changeFinnish") {
                $e867405a5d233f6c$var$renderContent("fi");
                (0, $k1bt3.setLanguage)("fi");
                languageFlags.forEach((flag)=>{
                    flag.classList.remove("active");
                });
                e.target.classList.add("active");
            } else if (e.target.id === "changeSwedish") {
                $e867405a5d233f6c$var$renderContent("sv");
                (0, $k1bt3.setLanguage)("sv");
                languageFlags.forEach((flag)=>{
                    flag.classList.remove("active");
                });
                e.target.classList.add("active");
            } else if (e.target.id === "changeEnglish") {
                $e867405a5d233f6c$var$renderContent("en");
                (0, $k1bt3.setLanguage)("en");
                languageFlags.forEach((flag)=>{
                    flag.classList.remove("active");
                });
                e.target.classList.add("active");
            }
        });
    }).then(()=>(0, $k1bt3.loadFooter)()).then(()=>(0, $k1bt3.setupNavBarLinks)()).then(()=>(0, $k1bt3.loadDefaultLanguage)()).then((lang)=>$e867405a5d233f6c$var$renderContent(lang));
// renderContent("fi");
});


//# sourceMappingURL=repo.3227ca81.js.map
